export const isHexColor = (val: string) => /^#[0-9a-f]{3,6}$/i.test(val);
